import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface Props {
  typeCode: string;
  value: string;
}

const IndicatorBadge: React.FC<Props> = ({ value, typeCode }) => (
  <div className="badge-base-indicator" title={typeCode === 'Hazards' ? value : ''}>
    {typeCode === 'Hazards' && (
      <span className="badge-base-indicator-clip">
        <FontAwesomeIcon icon="clipboard-list" />
      </span>
    )}
    <div className="badge-text-indicator">{typeCode !== 'Hazards' && <span>{value}</span>}</div>
  </div>
);

export default React.memo(IndicatorBadge);
